export function LogoMark({ className = "h-8 w-8", iconClassName = "h-4 w-4" }) {
  return (
    <div className={`${className} rounded-lg bg-zinc-900 grid place-items-center shrink-0`}>
      <svg
        viewBox="0 0 32 32"
        className={iconClassName}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Lens / aperture ring */}
        <circle cx="16" cy="16" r="9" stroke="white" strokeWidth="2.4" />
        {/* Ascending forecast line */}
        <path
          d="M9 18.5 L13.5 13.5 L17.5 16.5 L23 10.5"
          stroke="white"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Insight node — brand amber accent */}
        <circle cx="23" cy="10.5" r="2.3" fill="#f59e0b" />
      </svg>
    </div>
  );
}

export default function Logo({ wordmark = "Optics", dark = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark />
      <span className={`font-display font-semibold tracking-tight ${dark ? "text-white" : "text-zinc-900"}`}>
        {wordmark}
      </span>
    </div>
  );
}
